export default __webpack_public_path__ + "static/media/hjælpeløs_farve.cf1a95d8.png";